import React, { useEffect, useState } from "react";
import DataTable from "../ui/DataTable";
import { loadingCard } from "../../../helpers/loading";

interface TasksCompletedTableState {
  data: any;
}

export const TasksCompletedTable = ({ data }: TasksCompletedTableState): React.JSX.Element | null => {
  const [taskData, setTaskData] = useState<any[]>([]);

  const tableHeaders = [
    { label: "Case ID", key: "case_id", hide: true },
    { label: "Case", key: "case_name" },
    { label: "Goal ID", key: "goal_id", hide: true },
    { label: "Goal", key: "goal_name" },
    { label: "ID", key: "id", hide: true },
    { label: "Task", key: "task_name" },
    { label: "Name", key: "goal_subject.name", width: "200px" },
    { label: "Completed", key: "cm_reviewed_at_formatted", width: "100px" },
  ];

  useEffect(() => {
    if (data) {
      const { tasks } = data;
      setTaskData(tasks);
    }
  }, [data]);

  return taskData ? <DataTable tableHeadings={tableHeaders} tableData={taskData} title={"Tasks Completed"} /> : loadingCard();
};
